module.exports = __webpack_public_path__ + "img/532.58d2481d.png";